import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import DomPurify from "isomorphic-dompurify";

const { sanitize } = DomPurify;

export type TranslationHtmlWrapperProps = {
  text: string;
  htmlData: string[];
  className?: string;
};

export const TranslationHtmlWrapper: FC<TranslationHtmlWrapperProps> = ({ text, htmlData, className = "" }) => {
  const { __ } = useTranslations();
  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html: sanitize(__(text, htmlData), { ADD_ATTR: ["target"] }),
      }}
    />
  );
};
